import {ref, Ref} from "vue"

type CacheKey = string
const pricesLoadingSet: Ref<Set<CacheKey>> = ref(new Set<CacheKey>())

export default pricesLoadingSet